import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "../components/ui/accordion";
import { Link } from "react-router-dom";
import { Seo } from "../components/Seo";
import { PageHeader } from "../components/Bits";
import { Reveal } from "../components/Reveal";
import { FAQS } from "../lib/site";

export default function FAQ() {
  return (
    <>
      <Seo title="FAQ" path="/faq" description="Answers to common questions about the Grimsby On The Lake Turkey Trot." />
      <PageHeader
        chapter="good to know"
        title="Frequently asked questions."
        sub="Everything you need to know before race day. Still curious? Reach out any time."
      />

      <section className="mx-auto max-w-3xl px-5 sm:px-8 pb-24 sm:pb-32">
        <Reveal>
          <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
            {FAQS.map((f, i) => (
              <AccordionItem
                key={i}
                value={`item-${i}`}
                className="rounded-2xl bg-white border border-black/5 px-6 shadow-warm"
              >
                <AccordionTrigger className="text-left font-display text-xl sm:text-2xl font-semibold hover:no-underline py-5">
                  {f.q}
                </AccordionTrigger>
                <AccordionContent className="text-base text-ink-soft leading-relaxed pb-5">
                  {f.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </Reveal>

        <Reveal delay={0.1}>
          <div className="mt-10 text-center text-ink-soft">
            Didn't find your answer?{" "}
            <Link to="/contact" className="text-terracotta font-semibold hover:underline">
              Get in touch →
            </Link>
          </div>
        </Reveal>
      </section>
    </>
  );
}
